<template>
    <div>
        <div class="text-right">
            <b-button @click="modalSocialNetwork(null)" variant="primary"><i class="fa fa-mixcloud"></i> Nova Rede Social</b-button>
        </div>
        <br>

        <b-table
            :items="items"
            :fields="table.fields"
            :select-mode="table.selectMode"
            responsive="sm"
            ref="selectableTable"
            selectable
            :primary-key="table.primaryKey"
            :tbody-transition-props="table.transProps"
            sort-icon-left
            @row-clicked="modalSocialNetwork"
            :per-page="table.perPage"
            :current-page="table.currentPage"
            :busy="table.isBusy"
            hover
            striped>

            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Carregando...</strong>
                </div>
            </template>
            
            <template v-slot:cell(action)="data">
                <b-button size="sm" variant="danger" @click="deleteSocialNetwork(data.item)" class="mr-1 btn-brand"><i class="fa fa-close" alt="Excluir rede social" title="Excluir rede social"></i></b-button>
            </template>

        </b-table>

        <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Rede Social"
              size="lg"
              >
              
              <b-card>

                <b-form @submit.stop.prevent="onSubmit">

                <div class="animated fadeIn" v-if="selectedItem">
                    <b-row>
                        <b-col md="12">
                            <b-form-group
                            description=""
                            label="Rede social"
                            label-for="socialNetwork"
                            :label-cols="2"
                            :horizontal="true">
                                <b-form-select id="socialNetworkId"
                                    v-model="selectedItem.socialNetworkId"
                                    :plain="true"
                                    :options="socialNetworkDDL"
                                    :class="socialNetworkField"
                                    >
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Link"
                            label-for="url"
                            :label-cols="2"
                            :horizontal="true">
                              <b-form-input v-model="selectedItem.url" id="url" type="text" :class="urlField"></b-form-input>                               
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>


                    <div slot="footer" class="text-right">
                    <!--
                    <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
                    <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
                    <b-button variant="vine" class="mr-1 btn-brand" @click="create()"><i class="fa fa-tags"></i><span>Criar Etiquetas</span></b-button>
                    -->                    
                    <b-button variant="github" class="mr-1 btn-brand" @click="saveButton()"><i class="fa fa-print"></i><span>Salvar Rede Social</span></b-button>
                    
                    </div>
                        
                </div>
                </b-form>

                </b-card>

        </b-modal>

        <b-modal title="Excluir" class="modal-delete" v-model="deleteModal" @ok="deleteItem" cancel-title="Cancelar" >
            Deseja realmente excluir a rede social?
        </b-modal>
    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
    import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
    //import { table } from 'console'
    
    const toastTypes = {
      success: 'success',
      error: 'error',
      info: 'info',
      warn: 'warn'
    }
    
    miniToastr.init({types: toastTypes})
    
    function toast ({title, message, type, timeout, cb}) {
      return miniToastr[type](message, title, timeout, cb)
    }
    
    const options = {
      success: toast,
      error: toast,
      info: toast,
      warn: toast
    }
    VueNotifications.setPluginOptions(options)
    
    Vue.use(VueNotifications, options)
    /* Toast - End */
  
    export default {
      name: 'UserSocialNetworkComponent',
      props: {
        userId: 0
        /*
        item: {}, // Usuário, Pessoa ou Grupo de usuário
        socialNetworks: []  // Lista de redes sociais
        */
      },
      computed: {
          propUserId() {
            return this.userId
          }
          /*
          propItem() {
              return this.item
          },
          propSocialNetworks() {
            return this.socialNetworks
          }
          */
      },
      components: {
      },
      data: () => {
          return {
            items: [],
            urlField: '',
            socialNetworkField: '',
            socialNetworkDDL: [],
            editModal: false,
            deleteModal: false,
            selectedItem: null,
            table: {
              fields: [
                  {key: 'socialNetwork.name', label: 'Rede social', sortable: true, thStyle: { width: "150px" } },
                  {key: 'url', label: 'Link', sortable: true },
                  {key: 'action', label: '', sortable: false, thStyle: { width: "40px" }, tdClass: 'align-middle' },
              ],
              modes: ['multi', 'single', 'range'],
              selectMode: 'single',
              primaryKey: 'id',
              isBusy: false,
              currentPage: 1,
              totalRows: 0,
              perPage: 10,
              transProps: {
                  name: 'flip-list'
              }
            }
          }
      },
      methods: {
        async deleteItem() {
//            console.log("Excluindo")
//            console.log(this.selectedItem)
            var s = this
            var currentUser = this.$store.state.currentUser

            await axios.delete(
                this.$store.state.ws_url + "/user/socialnetwork?id=" + this.selectedItem.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp){
                s.refreshData()
            }).catch(function(error) {
                console.log(error)
            })
        },

        deleteSocialNetwork(item) {
            this.selectedItem = item
            this.deleteModal = true
        },

        async save(item) {
            var s = this
            var currentUser = this.$store.state.currentUser
            item.uid = currentUser.id
            item.sid = currentUser.sid

            await axios.post(
                this.$store.state.ws_url + "/user/socialnetwork",
                item
            ).then(function(resp) {
                s.editModal = false
                s.refreshData()
            }).catch(function(error) {
                console.log(error)
            })
        },

        saveButton() {
            var containsError = false
            if(!this.selectedItem.socialNetworkId || this.selectedItem.socialNetworkId <= 0) {
                this.socialNetworkField = "is-invalid"
                containsError = true
            }
            else {
                this.socialNetworkField = ""
            }

            if(this.selectedItem.url == '') {
                this.urlField = 'is-invalid'
                containsError = true
            }
            else {
                this.urlField = ''
            }

            if(!containsError) {
                this.save(this.selectedItem)
            }
        },

        modalSocialNetwork(item) {
            this.socialNetworkField = ''
            this.urlField = ''
            if(item == null) {
                this.selectedItem = {
                    userId: this.propUserId,
                    socialNetworkId: 0,
                    url: '',
                    isPublic: true
                }
            }
            else {
                this.selectedItem = item
            }
            
            this.editModal = true
        },

        async getSocialNetwork() {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            await axios.get(
                this.$store.state.ws_url + "/socialnetwork/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
                s.socialNetworkDDL = resp.data.obj;
            }).catch(function(error) {
            })
        },

        async refreshData() {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            await axios.get(
                this.$store.state.ws_url + "/user/socialnetwork?userId=" + s.propUserId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
                s.items = resp.data.obj;
            }).catch(function(error) {
            })
        }
      },
      mounted: function() {
        this.getSocialNetwork()
        this.refreshData()
      }
    }
  
  </script>